<template>
  <div
    style="
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 1200px;
      overflow: hidden;
    "
  >
    <div class="header between">
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/29/返回@2x (1)-140738562.png"
        alt=""
        style="width: 20px; height: 20px; cursor: pointer"
        @click="$router.back()"
      />
      <div style="font-size: 18px; color: #1d2129; line-height: 20px">
        管理后台
      </div>
      <el-image
        :src="user.avatar"
        class="photo rounded"
        v-if="user.avatar"
      ></el-image>
      <div v-else class="photo center rounded">{{ user.name?.[0] }}</div>
    </div>
    <div style="height: calc(100vh - 52px); display: flex">
      <div class="slider">
        <div v-for="(item, index) in adminRouters" :key="index">
          <div
            class="title"
            style="font-size: 14px; color: #838892; line-height: 16px"
          >
            {{ item.name }}
          </div>
          <div
            v-for="(item, index) in item.routers"
            :key="index"
            class="item"
            :class="{ active: $route.path === item.path }"
            @click="$router.replace(item.path)"
          >
            <svg-icon :icon-class="item.icon + ''"></svg-icon>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div style="width: 100%; height: 100%; background: #fff">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // active: 0,
      adminRouters: [
        {
          name: "人员管理",
          routers: [
            {
              name: "用户管理",
              path: "/cmsAdmin/user",
              icon: "icon_admin_user",
            },
            {
              name: "角色权限管理",
              path: "/cmsAdmin/role",
              icon: "icon_admin_role",
            },
          ],
        },
        {
          name: "数据记录",
          routers: [
            {
              name: "数据日志",
              path: "/cmsAdmin/dataLog",
              icon: "icon_admin_dataLog",
            },
            {
              name: "应用日志",
              path: "/cmsAdmin/moduleLog",
              icon: "icon_admin_applicationLog",
            },
            {
              name: "登录日志",
              path: "/cmsAdmin/loginLog",
              icon: "icon_admin_loginLog",
            },
          ],
        },
        {
          name: "首页配置",
          routers: [
            {
              name: "模板配置",
              path: "/cmsAdmin/template",
              icon: "icon_admin_template",
            },
            {
              name: "解决方案配置",
              path: "/cmsAdmin/solution",
              icon: "icon_admin_solution",
            },
          ],
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.getters.userInfo;
    },
  },
};
</script>

<style scoped lang="less">
.header {
  height: 52px;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px 0px #e5e6eb;
  padding: 0 10px 0 20px;
}

.slider {
  width: 200px;
  box-shadow: inset -1px 0px 0px 0px #e5e6eb;
  height: 100%;
  padding: 24px 8px;
  .title {
    margin-top: 6px;
    margin-bottom: 8px;
    padding-left: 6px;
  }
  .item {
    height: 36px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
    padding: 10px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    color: #1d2129;
    line-height: 16px;

    &:hover {
      background: #ecf5ff;
      color: #107fff;
    }
    &.active {
      background: #ecf5ff;
      color: #107fff;
    }
  }
}

.content {
  padding: 16px;
  background: #f5f7fa;
  height: 100%;
  flex: 1;
  overflow: hidden;
}

.photo {
  width: 34px;
  height: 34px;
  background: #107fff;
  color: #fff;
  border: 1px solid #ffffff;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
}
</style>